import { render, staticRenderFns } from "./TechNicheIcon.vue?vue&type=template&id=239106cb&scoped=true"
import script from "./TechNicheIcon.vue?vue&type=script&lang=js"
export * from "./TechNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239106cb",
  null
  
)

export default component.exports